import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import "./index.scss";
import "antd/dist/reset.css";
import App from "./app";
import store from "./redux";
import * as serviceWorker from "./serviceWorker";
import DynamicThemeProvider from "./theme";

ReactDOM.render(
  <Provider store={store}>
    <DynamicThemeProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </DynamicThemeProvider>
  </Provider>,
  document.getElementById("root"),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
